<template>
    <base-dialog  :visible="true" visible @close="close" :showFooter="false" :title="title" id="test">
        <div class="my-15" v-loading="loading">
            <maximise-speed v-if="type==='speed'"/>
            <template v-else>
                <kp-list :data="KPcontactList" />
                <concat-item :data="contactList" class="mt-15"/>
            </template>
        </div>
    </base-dialog>
</template>
<script>
import BaseDialog  from "@/components/common/BaseDialog.vue";
    
    import ConcatItem from '../client-concat';
    import KpList from '../kpmg-concat';
    import maximiseSpeed from '../maximise-speed'

    export default {
        name: 'ContactSpeedInfo',
        props:{
            type: {
                type: String,
                default: () => "contact",//contact|speed
            },
            contactList: {
                type: Array,
                default: () => [],
            },
            KPcontactList: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                active: '2',
                loading: false,
                visible: false,
            };
        },
        computed: {
            title(){
                return this.type==='contact'?this.$t('client_home.clientContact'):this.$t('client_home.recommendTitle')
            }
        },
        methods: {
            close(){
                this.$emit('close')
            },
        },
        components: {
            ConcatItem,
            KpList,
            maximiseSpeed,
            BaseDialog
        }
    };
</script>

